export default function(){
	let contentBoxes = document.querySelectorAll( '[data-name="content-box-full-width"]' )

	if ( contentBoxes.length > 0 ){
		contentBoxes.forEach(box => {
			if ( box.clientHeight > 420 ){
				box.querySelector( '[data-name="shape-1"]' )?.classList.remove('hidden')
			}
			if ( box.clientHeight > 720 ){
				box.querySelector( '[data-name="shape-2"]' )?.classList.remove('hidden')
			}
			if ( box.clientHeight > 900 ){
				box.querySelector( '[data-name="shape-3"]' )?.classList.remove('hidden')
			}
		});
	}
}